<div class="comments">
 

    @if(titleText() || titleTranslationKey()){
      <p [class]="titleClasses()">
        {{
        titleText() ??
        (titleTranslationKey() | transloco: { scope: titleTranslationScope() })
        }}
      </p>
    }
    @if(!hasPermissionToPostComments()) {
      <p class="mb-2" *transloco="let t; scope: 'social'">{{t('social.conversation.commenting_locked')}}</p>
    } @else if (descriptionText() || descriptionTranslationKey()) {
      <p class="mb-2">
        {{
        descriptionText() ??
        (descriptionTranslationKey() | transloco: { scope: descriptionTranslationScope() })
        }}
      </p>

    }
    <div>
      <frontend-comment-form-type-two
        [user]="user()"
        (postComment)="doPostComment($event)"
        [clearCommentForm]="clearCommentForm()"
        [loading]="loadingComments()"
        [disabled]="disabled() || !hasPermissionToPostComments()"
        [formCachingKey]="formCachingKey()"

        [translatablePairs]="translatablePairs()"
        >
      </frontend-comment-form-type-two>
    </div>

    <div [class.card-gray-200]="!hasPermissionToReadComments()" [class.comments-locked]="!hasPermissionToReadComments()" [class.position-relative]="!hasPermissionToReadComments()">

        @if(!hasPermissionToReadComments()) {
          <multisite-locked-content-mask-type-two
            class="locked-content"
            [titleTranslationKey]="lockTitleTranslationKey()"
            [descriptionTranslationKey]="lockDescriptionTranslationKey()"
            [iconClasses]="'fa-solid fa-unlock-alt'"
            [cta_translationKey]="lockCtaTranslationKey()"
            (lockLinkClicked)="doLockLinkClicked()"
          ></multisite-locked-content-mask-type-two>
        }
       <div [class.locked-blur]="!hasPermissionToReadComments()">


         @if (displayPaginatedComments()?.meta?.total) {
           <div
             class="card-header border-0 grey lighten-3"
             >
             <h6 class="my-3">
               {{ ('social.'+
                ((displayPaginatedComments().meta.total < 6)
                ?
                displayPaginatedComments().meta.total
               :
               5)+'_comments') | transloco:{'number':displayPaginatedComments().meta.total, scope:'social'}
               }}
               </h6
               >
             </div>
         }
       
         @if (displayPaginatedComments()?.data) {
           <div>
             @for (comment of displayPaginatedComments().data; track comment) {
               <frontend-comment-type-two
                 [comment]="comment"
                 >
               </frontend-comment-type-two>
             }
             </div>
         }
       </div>

    </div>


  <!--Pagination -->
  <div class="my-3">
    @if (displayPaginatedComments()?.meta && displayPaginatedComments().meta.last_page > 1) {
      <frontend-pagination-type-three
        [classes]="'pg-purple justify-content-center'"
        [loading]="loadingComments() || disabled()"
        [meta]="displayPaginatedComments().meta"
        [lastPage]="displayPaginatedComments().meta.last_page"
        [links]="displayPaginatedComments().links"
        (changePage)="doGetComments($event)"
        >
      </frontend-pagination-type-three>
    }
  </div>
    <!--Pagination -->
  </div>